export default __webpack_public_path__ + "static/media/rtl.55bd2d30.svg";